import {Stack} from '@mui/material';
import styled from 'styled-components';

export const StyledRowStack = styled(Stack)
  .attrs((props) => ({...props, direction: 'row', spacing: 7}))`
    width: 100%;
  `;
